// Hook to run server-side constructor when instances start.

// This hook checks if the instance has been initialized and triggers the server to create default data.
import { useEffect } from 'react';
import { useDatastore, useGlobalProperty, useInstanceKey, useStructureKey } from 'util/datastore';

export function useServersideConstructor() {
    const initialized = useGlobalProperty('initialized');
    const datastore = useDatastore();
    const instanceKey = useInstanceKey();
    const structureKey = useStructureKey();

    useEffect(() => {
        if (!initialized) {
            datastore.callServerAsync('constructor', 'runConstructor', {
                structureKey,
                instanceKey,
            });
        }
    }, [instanceKey, structureKey]);
    return initialized;
}
